import React from 'react';
import { motion } from 'framer-motion';
import { IScrollIcon } from './ScrollIkon.definition';

const Icon = () => <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m15.142 19.073-7.07 7.071L1 19.074M8.001 26V0" stroke="#92004D" strokeWidth="2" /></svg>;

const ScrollIcon = (props: IScrollIcon) => {
	const {
		id
	} = props;

	const handleClick = (e: React.SyntheticEvent) => {
		e.preventDefault();

		if (props.scrollToEl) {
			props.scrollToEl.scrollIntoView({
				behavior: 'smooth'
			});
		}
	};

	return (
		<motion.div
			animate={ { opacity: 0 } }
			transition={ { repeat: Infinity, ease:'linear', repeatType: 'reverse', duration: 1 } }
			style={ { position: 'absolute', bottom: '1rem' } }
			className="text-center w-100">

			{ props.scrollToEl && (
				<a
					onClick={ handleClick }
					style={ { padding: '0 1rem', minHeight: '28px' } }
					id={ id }
				>
					<Icon />
				</a>
			) }

			{ !props.scrollToEl &&
				<Icon /> }

		</motion.div>
	);
};


export default ScrollIcon;